// material-ui
import { ListItemText } from "@mui/material";

// project imports
import { useLocation, useNavigate } from "react-router-dom";

import { useSelector } from "react-redux";
import StyledListItemButton from "./commons/StyledListItemButton";

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = ({ menuItems }) => {
  let location = useLocation();
  let activeMenuItems = menuItems?.[0];
  menuItems?.forEach((item) =>
    item?.children?.forEach((subitem) => {
      if (location?.pathname === subitem?.url) {
        activeMenuItems = item;
      }
    })
  );

  const customization = useSelector((state) => state.customization);
  const navigate = useNavigate();

  const navItems = activeMenuItems?.children?.map((item, index) => {
    return (
      <StyledListItemButton
        key={index}
        selected={location.pathname === item.url}
        onClick={() => navigate(item.url)}
        customization={customization}
        width="122px"
      >
        {item.icon}
        <ListItemText>{item.title}</ListItemText>
      </StyledListItemButton>
    );
  });
  return <>{navItems}</>;
};

export default MenuList;
